export const PermissionDeniedMessages = {
    DeleteCondition: "You don't have permission to delete tasks/conditions.",
    ResolveCondition: "You don't have permission to resolve tasks/conditions.",
    EditCondition: "You don't have permission to edit tasks/conditions.",
};
